import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";

export interface ExchangerRequest {
  amount: string;
  currency: string; // IRI like "/currencies/6"
}

export interface ExchangerResponse {
  amount: string;
  currency: string; // IRI like "/currencies/6"
  convertedAmount?: string; // Only present if conversion exists
  convertedCurrency?: string; // IRI only present if conversion exists
}

export default function useExchangerGet(
    request?: ExchangerRequest,
    options?: CacheQueryOpts<ExchangerResponse>
): CacheQueryOutput<ExchangerResponse> {
    const client = useAPIClient();

    return useCacheQuery<ExchangerResponse>(
        ["exchanger", request?.amount, request?.currency],
        () => {
            if (!request) throw new Error("No exchanger request provided");
            return client.post<ExchangerResponse>("exchanger", request);
        },
        {
            execute: !!request,
            ...options,
        }
    );
}
